"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PackageUnderstandingSkippedEvent = exports.PackageUnderstandingWizardPlanSkippedEvent = exports.PackageCatalogueUnderstandingCompletedEvent = exports.PackageCatalogueExactMatchDetectedEvent = exports.PackageUnderstandingFailedEvent = exports.PackageUnderstandingCompletedEvent = exports.PackageUnderstandingStartedEvent = exports.DatasheetEnsureCompletedEvent = exports.DatasheetReplacementCompletedEvent = exports.DatasheetValidationRecordedEvent = exports.DatasheetFetchCompletedEvent = exports.DatasheetFetchStartedEvent = exports.PackageDatasheetSearchCompletedEvent = exports.PackageDatasheetSearchStartedEvent = exports.ConnectorCatalogueResolvedEvent = void 0;
const zod_1 = require("zod");
const event_1 = require("../event");
const build_ancestry_1 = require("../build-ancestry");
const package_milestone_enums_1 = require("./package-milestone-enums");
const package_datasheet_validation_1 = require("../../PackageStore/package-datasheet-validation");
const package_datasheet_state_1 = require("../../PackageStore/package-datasheet-state");
const datasheet_ensure_1 = require("../../PackageStore/datasheet-ensure");
exports.ConnectorCatalogueResolvedEvent = (0, event_1.createEventClass)('ConnectorCatalogueResolvedEvent', zod_1.z.object({
    packageId: zod_1.z.string(),
    projectModuleId: zod_1.z.string(),
    sigmaModelId: zod_1.z.string(),
    pinNames: zod_1.z.array(zod_1.z.string()),
}));
exports.PackageDatasheetSearchStartedEvent = (0, event_1.createEventClass)('PackageDatasheetSearchStartedEvent', zod_1.z.object({
    packageId: zod_1.z.string(),
    mpn: zod_1.z.string(),
    hasSeedUrl: zod_1.z.boolean(),
}));
exports.PackageDatasheetSearchCompletedEvent = (0, event_1.createEventClass)('PackageDatasheetSearchCompletedEvent', zod_1.z.object({
    packageId: zod_1.z.string(),
    mpn: zod_1.z.string(),
    outcome: zod_1.z.nativeEnum(package_milestone_enums_1.DatasheetSearchOutcome),
    source: zod_1.z.nativeEnum(package_milestone_enums_1.DatasheetSearchSource),
    fileId: zod_1.z.string().nullable(),
}));
exports.DatasheetFetchStartedEvent = (0, event_1.createEventClass)('DatasheetFetchStartedEvent', zod_1.z.object({
    contextKind: zod_1.z.nativeEnum(package_milestone_enums_1.DatasheetContextKind),
    contextId: zod_1.z.string(),
    mpn: zod_1.z.string(),
    hasSeedUrl: zod_1.z.boolean(),
}));
exports.DatasheetFetchCompletedEvent = (0, event_1.createEventClass)('DatasheetFetchCompletedEvent', zod_1.z.object({
    contextKind: zod_1.z.nativeEnum(package_milestone_enums_1.DatasheetContextKind),
    contextId: zod_1.z.string(),
    mpn: zod_1.z.string(),
    outcome: zod_1.z.nativeEnum(package_milestone_enums_1.DatasheetSearchOutcome),
    source: zod_1.z.nativeEnum(package_milestone_enums_1.DatasheetSearchSource),
    fileId: zod_1.z.string().nullable(),
    deadEnd: zod_1.z.nativeEnum(package_milestone_enums_1.DatasheetUrlDeadEnd).optional(),
}));
exports.DatasheetValidationRecordedEvent = (0, event_1.createEventClass)('DatasheetValidationRecordedEvent', zod_1.z.object({
    packageId: zod_1.z.string(),
    fileId: zod_1.z.string(),
    mpn: zod_1.z.string(),
    matches: zod_1.z.boolean(),
    kind: zod_1.z.nativeEnum(package_datasheet_validation_1.DatasheetValidationVerdictKind),
}));
exports.DatasheetReplacementCompletedEvent = (0, event_1.createEventClass)('DatasheetReplacementCompletedEvent', zod_1.z.object({
    packageId: zod_1.z.string(),
    mpn: zod_1.z.string(),
    rejectedFileId: zod_1.z.string(),
    rejectedKind: zod_1.z.nativeEnum(package_datasheet_validation_1.DatasheetValidationVerdictKind).optional(),
    outcome: zod_1.z.nativeEnum(package_datasheet_validation_1.DatasheetReplacementOutcome),
    candidateFileId: zod_1.z.string().nullable(),
}));
exports.DatasheetEnsureCompletedEvent = (0, event_1.createEventClass)('DatasheetEnsureCompletedEvent', zod_1.z.object({
    packageId: zod_1.z.string(),
    requestReason: zod_1.z.nativeEnum(datasheet_ensure_1.DatasheetEnsureRequestReason),
    outcome: zod_1.z.nativeEnum(datasheet_ensure_1.DatasheetEnsureOutcome),
    reason: zod_1.z.nativeEnum(package_datasheet_state_1.DatasheetStateReason).optional(),
    source: zod_1.z.nativeEnum(datasheet_ensure_1.DatasheetEnsureSource),
    attempt: zod_1.z.number().int().optional(),
    fileId: zod_1.z.string().nullable(),
}));
exports.PackageUnderstandingStartedEvent = (0, event_1.createEventClass)('PackageUnderstandingStartedEvent', zod_1.z.object({
    ...build_ancestry_1.buildAncestryShape,
    packageId: zod_1.z.string(),
    workflowId: zod_1.z.string().nullable(),
    hasDatasheet: zod_1.z.boolean(),
    hasCatalogueItems: zod_1.z.boolean(),
    sigmaModelType: zod_1.z.string(),
    pinCount: zod_1.z.number().int().nullable(),
}));
exports.PackageUnderstandingCompletedEvent = (0, event_1.createEventClass)('PackageUnderstandingCompletedEvent', zod_1.z.object({
    ...build_ancestry_1.buildAncestryShape,
    packageId: zod_1.z.string(),
    workflowId: zod_1.z.string().nullable(),
    outcome: zod_1.z.nativeEnum(package_milestone_enums_1.PackageUnderstandingOutcome),
    failedSteps: zod_1.z.array(zod_1.z.string()).optional(),
    sigmaModelType: zod_1.z.string(),
    pinCount: zod_1.z.number().int().nullable(),
    signalCount: zod_1.z.number().int(),
}));
exports.PackageUnderstandingFailedEvent = (0, event_1.createEventClass)('PackageUnderstandingFailedEvent', zod_1.z.object({
    ...build_ancestry_1.buildAncestryShape,
    packageId: zod_1.z.string(),
    workflowId: zod_1.z.string().nullable(),
    errorMessage: zod_1.z.string(),
    sigmaModelType: zod_1.z.string(),
    pinCount: zod_1.z.number().int().nullable(),
}));
exports.PackageCatalogueExactMatchDetectedEvent = (0, event_1.createEventClass)('PackageCatalogueExactMatchDetectedEvent', zod_1.z.object({
    packageId: zod_1.z.string(),
    catalogueName: zod_1.z.string(),
    catalogueMpn: zod_1.z.string(),
    catalogueManufacturerName: zod_1.z.string(),
    hasDatasheetUrl: zod_1.z.boolean(),
}));
exports.PackageCatalogueUnderstandingCompletedEvent = (0, event_1.createEventClass)('PackageCatalogueUnderstandingCompletedEvent', zod_1.z.object({
    packageId: zod_1.z.string(),
    resolutionGenerated: zod_1.z.boolean(),
    skippedReason: zod_1.z.string().nullable(),
    sigmaModelTypeAfter: zod_1.z.string(),
    pinCount: zod_1.z.number().int().nullable(),
}));
exports.PackageUnderstandingWizardPlanSkippedEvent = (0, event_1.createEventClass)('PackageUnderstandingWizardPlanSkippedEvent', zod_1.z.object({
    packageId: zod_1.z.string(),
    planSkipReason: zod_1.z.string(),
}));
exports.PackageUnderstandingSkippedEvent = (0, event_1.createEventClass)('PackageUnderstandingSkippedEvent', zod_1.z.object({
    ...build_ancestry_1.buildAncestryShape,
    packageId: zod_1.z.string(),
    skipCause: zod_1.z.nativeEnum(package_milestone_enums_1.PackageUnderstandingSkipCause),
    hasDatasheet: zod_1.z.boolean().optional(),
    hasCatalogueItems: zod_1.z.boolean().optional(),
}));
//# sourceMappingURL=package-understanding-events.js.map